import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Filter } from 'module-tsl-ui-filter';
import WithDocgen from 'module-tsl-ui-filter/with-docs/Filter';
import pkg from 'module-tsl-ui-filter/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`
  <div style={{ marginLeft: 200 }}> 
    <Filter
      onClose={() => console.log('closed')}
      onClearAndApply={() => console.log('clear and apply')}
      onClear={() => console.log('clear')}
      onApply={() => console.log('apply')}
      popoverPush={null}
    >
      <div style={{ width: 300, padding: 20 }}>Filters logic inside</div>
    </Filter>
  </div>
`}
  scope={ { Filter } }
/>
<MDXTag name="h3" components={components} props={{"id":"Info"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#Info","aria-label":"Info permalink","class":"anchor"}}></MDXTag>{`Info`}</MDXTag>
<MDXTag name="p" components={components}>{`Have a look at the storybook link to see how it works`}</MDXTag>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-filter --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  